// megaMenuDataNew.js
// Estructura Physiology - Mega Menu con colores por categoría para tablet
// hasCard: true = activa la card hover con imagen y descripción

export const menuCategories = [
  // ============================================
  // 1. ARRIVALS - Cards hover en columna izquierda
  // ============================================
  {
    id: 'novedades',
    title: 'Arrivals',
    hasMegaMenu: true,
    backgroundColor: '#f0ebe6', // Color suave beige para tablet
    defaultImage: '/images/megamenu/arrivals-default.webp',
    cta: {
      title: 'Descubre lo nuevo',
      subtitle: 'Últimos lanzamientos',
      url: '/novedades'
    },
    columns: [
      {
        title: 'Nuevos lanzamientos',
        hasArrow: false,
        links: [
          {
            label: 'Antioxidante Serum Vitamina C',
            url: '/products/serum-vitamina-c-pura-12-20',
            image: '/images/products/Textura_vitamina_c_serum_physiology_skincare.webp',
            description: 'Protege de los radicales libres y brinda luminosidad',
            hasCard: true
          },
          {
            label: 'Restorative Hydra Cream',
            url: '/products/restorative-hydra-cream',
            image: '/images/products/Restorative_hydra_cream_physiology_skincare_portada.webp',
            description: 'Hidratación profunda para pieles secas',
            hasCard: true
          },
          {
            label: 'The Journey Kit',
            url: '/products/the-journey-kit',
            image: '/images/products/Kit_de_viaje_aura_physiology_galeria.webp',
            description: 'Todo lo esencial para tu rutina de viaje',
            hasCard: true
          },
          {
            label: 'Triada Anti Manchas',
            url: '/products/triada-anti-manchas',
            image: '/images/products/Triada_antimanchas_serums_physiology_skincare.webp',
            description: 'Tratamiento completo para una piel uniforme',
            hasCard: true
          },
        ]
      },
      {
        title: 'Productos Destacados',
        hasArrow: false,
        links: [
          { label: 'Kit Minimalista', url: '/products/kit-minimalista-basico' },
          { label: 'Tónico Centella Asiática', url: '/products/tonico-centella-asiatica' },
          { label: 'Aurora — The Journey Kit I', url: '/products/the-journey-kit' },
          { label: 'Ultrabarrier repair', url: '/products/ultra-barrier-repair-60ml' },
        ]
      },
    ],
  },

  // ============================================
  // 2. CATÁLOGO - 4 columnas, links normales
  // ============================================
  {
    id: 'rostro',
    title: 'Catálogo',
    hasMegaMenu: true,
    backgroundColor: '#e8e5e0', // Color gris cálido
    defaultImage: '/images/megamenu/catalog-default.webp',
    cta: {
      title: 'Explora todo',
      subtitle: 'Nuestro catálogo completo',
      url: '/shop'
    },
    columns: [
      {
        title: 'Descubre el cuidado de la piel',
        hasArrow: true,
        links: [
          { label: 'Todo skincare', url: '/shop' },
          { label: 'Limpiadores', url: '/shop?category=limpiadores' },
          { label: 'Exfoliantes', url: '/shop?category=exfoliantes' },
          { label: 'Tónicos y Esencias', url: '/shop?category=tonicos' },
          { label: 'Sueros', url: '/shop?category=sueros' },
          { label: 'Correctivos', url: '/shop?category=correctivos' },
          { label: 'Tratamientos', url: '/shop?category=tratamientos' },
          { label: 'Hidratantes', url: '/shop?category=hidratantes' },
          { label: 'Nuestra selección', url: '/curated-selection' },
        ]
      },
      {
        title: 'Tipo de piel',
        hasArrow: false,
        links: [
          { label: 'Normal', url: '/shop?skin=Normal' },
          { label: 'Seca', url: '/shop?skin=Seca' },
          { label: 'Grasa', url: '/shop?skin=Grasa' },
          { label: 'Mixta', url: '/shop?skin=Mixta' },
          { label: 'Sensible', url: '/shop?skin=Sensible' },
        ]
      },
      {
        title: 'Preocupación de la piel',
        hasArrow: false,
        links: [
          { label: 'Acné', url: '/shop?concern=Acné' },
          { label: 'Manchas', url: '/shop?concern=Manchas' },
          { label: 'Arrugas', url: '/shop?concern=Arrugas' },
          { label: 'Poros dilatados', url: '/shop?concern=Poros dilatados' },
          { label: 'Luminosidad', url: '/shop?concern=Luminosidad' },
          { label: 'Hidratación', url: '/shop?concern=Hidratación' },
        ]
      },
      {
        title: 'Nuevas adiciones',
        hasArrow: false,
        links: [
          { label: 'RESURGE Advance Phase I', url: '/products/resurge-advance-phase-i-serum' },
          { label: 'RESURGE TONIC Phase II', url: '/products/resurge-tonic-phase-2' },
          { label: 'SOMA Lacta Phase I', url: '/products/soma-lacta-phase-i-serum' },
        ]
      }
    ],
  },

  // ============================================
  // 3. COMPENDIO
  // ============================================
  {
    id: 'cuerpo',
    title: 'Compendio',
    hasMegaMenu: true,
    backgroundColor: '#ded9d4', // Color terracota suave
    defaultImage: '/images/megamenu/compendium-default.webp',
    cta: {
      title: 'Guías y recursos',
      subtitle: 'Aprende más sobre skincare',
      url: '/compendio'
    },
    columns: [
      {
        title: 'Descubre Mano y cuerpo',
        hasArrow: true,
        links: [
          { label: 'Limpiadores corporales', url: '#' },
          { label: 'Exfoliantes', url: '#' },
          { label: 'Hidratantes', url: '#' },
          { label: 'Cuidado de manos', url: '#' },
          { label: 'Cuidado personal', url: '#' },
          { label: 'Protección solar', url: '#' },
          { label: 'Ver todo Mano y cuerpo', url: '#' },
        ]
      },
      {
        title: 'Destacados',
        hasArrow: false,
        links: [
          { label: 'Restorative Hydra Cream', url: '#' },
          { label: 'Tónico Centella Asiatica', url: '#' },
          { label: 'Kit Minimalista (travel)', url: '#' },
        ]
      }
    ]
  },

  // ============================================
  // 4. MANIFIESTO
  // ============================================
  {
    id: 'hogar',
    title: 'Manifiesto',
    hasMegaMenu: true,
    backgroundColor: '#e4dfd9', // Color arena
    defaultImage: '/images/megamenu/manifesto-default.webp',
    cta: {
      title: 'Nuestra filosofía',
      subtitle: 'Conoce más sobre Physiology',
      url: '/manifiesto'
    },
    columns: [
      {
        title: 'Descubrir',
        hasArrow: true,
        links: [
          { label: 'Nuestra historia', url: '/nuestra-historia' },
          { label: 'Filosofía', url: '/filosofia' },
          { label: 'Ingredientes', url: '/ingredientes' },
          { label: 'Sostenibilidad', url: '/sostenibilidad' },
          { label: 'Prensa', url: '#' },
        ]
      },
      {
        title: 'Comunidad',
        hasArrow: false,
        links: [
          { label: 'Eventos', url: '#' },
          { label: 'Colaboraciones', url: '#' },
          { label: 'Embajadores', url: '#' },
        ]
      }
    ],
  },

  // ============================================
  // 5. KITS DE VIAJE
  // ============================================
  {
    id: 'fragancias',
    title: 'Kits de viaje',
    hasMegaMenu: true,
    backgroundColor: '#d9d4ce', // Color gris perla
    defaultImage: '/images/megamenu/travel-kits-default.webp',
    // Imagen pequeña (macro del clutch cosmético) arriba del promo. Solo esta sección.
    // TEMPORAL: usando compendio.webp como marcador de posición hasta tener el
    // render del clutch (reemplazar por /images/megamenu/travel-clutch-macro.webp).
    promoImage: '/images/megamenu/compendio.webp',
    promoImageAlt: 'Clutch cosmético Physiology con productos de viaje',
    cta: {
      title: 'Viaja con estilo',
      subtitle: 'Kits perfectos para llevar',
      url: '/kits-viaje'
    },
    columns: [
      {
        title: 'Descubrir Kits',
        hasArrow: true,
        links: [
          { label: 'Aurora — The Journey Kit I', url: '/products/the-journey-kit' },
          { label: 'Odyssey — The Journey Kit II', url: '/products/the-journey-kit-ii' },
          { label: 'Eclipse — The Journey Kit III', url: '/products/the-journey-kit-iii' },
          { label: 'Kit Minimalista', url: '/products/kit-minimalista-basico' },
        ]
      },
      {
        title: 'Por necesidad',
        hasArrow: false,
        links: [
          { label: 'Hidratación', isLabel: true },
          { label: 'Anti-edad', isLabel: true },
          { label: 'Luminosidad', isLabel: true },
        ]
      },
    ]
  },

  // ============================================
  // 6. AFILIADOS
  // ============================================
  {
    id: 'regalos',
    title: 'Afiliados',
    hasMegaMenu: true,
    backgroundColor: '#f2ede8', // Color crema claro
    // TEMPORAL: falta la imagen propia de Afiliados (affiliates-default.webp).
    defaultImage: '/images/megamenu/manifesto-default.webp',
    isMapSection: true,
    columns: [
      {
        title: 'Encuentra un afiliado',
        hasArrow: false,
        isSearchBox: true,
        links: []
      },
    ]
  },

  // ============================================
  // 7. ARCHIVO - Blog con artículos
  // ============================================
  {
    id: 'citas',
    title: 'Archivo',
    hasMegaMenu: true,
    backgroundColor: '#ebe6e1', // Color hueso
    defaultImage: '/images/megamenu/archive-default.webp',
    cta: {
      title: 'Lee más',
      subtitle: 'Artículos y guías',
      url: '/archivo'
    },
    columns: [
      {
        title: 'The Asurbanipal',
        hasArrow: true,
        links: [
          { label: 'Ver todos los artículos', url: '/journal' },
        ]
      },
      {
        title: 'Últimas ediciones',
        hasArrow: false,
        links: [
          { label: 'physiology® — Acid System', url: '#', readTime: '5 minutos' },
          { label: 'Esencias Physiology', url: '#', readTime: '4 minutos' },
          { label: 'Ácido Azelaico 15% de Physiology', url: '#', readTime: '3 minutos' },
          { label: 'Una comprensión profunda: Vitamina C', url: '#', readTime: '3 minutos' },
          { label: 'Cómo tratar una piel deshidratada', url: '#', readTime: '5 minutos' },
          { label: 'Tono desigual de la piel', url: '#', readTime: '8 minutos' },
        ]
      },
    ]
  },

  // ============================================
  // LINK SIMPLE - Socios (Programa de distribuidoras)
  // ============================================
  {
    id: 'leer',
    title: 'Socios',
    hasMegaMenu: false,
    url: '/socio'
  },
];

export const megaMenuCategories = menuCategories.filter(cat => cat.hasMegaMenu);
export const simpleLinks = menuCategories.filter(cat => !cat.hasMegaMenu);
